import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";

interface InactivityModalProps {
  open: boolean;
  handleClose: () => void;
  handleResetQueue: () => void;
  countdown: number; // Add countdown prop
}

export const InactivityModal: React.FC<InactivityModalProps> = ({ open, handleClose, handleResetQueue, countdown }) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Inactivity Warning</DialogTitle>
      <DialogContent>
        "Warning: Inactivity detected. You have 1 minute to continue reviewing this case, or the queue will reset{" "}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Stay Signed In</Button>
        <Button onClick={handleResetQueue} color="warning">
          Reset Queue ({countdown})
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const showNotification = () => {
  // Check if the browser supports notifications
  if (!("Notification" in window)) {
    return;
  }

  // Request permission from the user
  if (Notification.permission !== "granted") {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        // If the user grants permission, trigger the notification
        new Notification("Inactivity Warning", {
          body: "Warning: Inactivity detected. You have 1 minute to continue reviewing this case, or the queue will reset",
        });
      }
    });
  } else {
    // If permission is already granted, trigger the notification
    new Notification("Inactivity Warning", {
      body: "Warning: Inactivity detected. You have 1 minute to continue reviewing this case, or the queue will reset",
    });
  }
};

export const InactivityAlert = (props: { open: boolean }) => {
  const { open } = props;
  // Simulate triggering the notification when the component mounts

  React.useEffect(() => {
    if (open) {
      showNotification();
    }
  }, [open]);

  return <div></div>; // This component doesn't render anything
};
